import { render, staticRenderFns } from "./checkup-results-charts.vue?vue&type=template&id=1a8696ba&"
import script from "./checkup-results-charts.vue?vue&type=script&lang=js&"
export * from "./checkup-results-charts.vue?vue&type=script&lang=js&"
import style0 from "./checkup-results-charts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports